import { useEffect, useState } from 'react';
import { Icon } from './Icon.tsx';

const DISMISS_KEY = 'wapsign.iosHint.dismissed';

function isIosStandaloneEligible(): boolean {
  if (typeof window === 'undefined') return false;
  const ua = navigator.userAgent;
  const isIos = /iPad|iPhone|iPod/.test(ua);
  const inStandalone = window.matchMedia('(display-mode: standalone)').matches
    || (navigator as Navigator & { standalone?: boolean }).standalone === true;
  return isIos && !inStandalone;
}

export function IosInstallHint(): JSX.Element | null {
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (!isIosStandaloneEligible()) return;
    if (localStorage.getItem(DISMISS_KEY) === '1') return;
    setShow(true);
  }, []);

  if (!show) return null;

  function dismiss(): void {
    localStorage.setItem(DISMISS_KEY, '1');
    setShow(false);
  }

  return (
    <div
      className="mx-4 mb-4 mt-2 rounded-lg border border-border bg-card p-3 text-sm flex items-start gap-3"
      style={{ paddingBottom: 'calc(0.75rem + env(safe-area-inset-bottom))' }}
    >
      <Icon name="ios_share" size={18} className="mt-0.5 shrink-0 text-primary" />
      <div className="flex-1">
        <p className="font-medium">Install WapSign</p>
        <p className="text-xs text-muted-foreground mt-0.5">
          Tap <span className="font-medium">Share</span> in Safari, then <span className="font-medium">Add to Home Screen</span>.
        </p>
      </div>
      <button onClick={dismiss} aria-label="Dismiss install hint" className="rounded p-1 hover:bg-muted">
        <Icon name="close" size={14} />
      </button>
    </div>
  );
}
